module.exports = __webpack_public_path__ + "img/vu.e1621e40.svg";